/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";

const StyledHeaderLink = styled.div`
  ${({ theme }) => `
  font-weight: 700;
  overflow: hidden;
  
  .header-link-label {
    font-size: 12px;
    color: white;
    margin: 0;
  }

  .header-link-text {
    font-size: 16px;
    margin:0;
    color: ${theme.palette.secondary.light};
  }
  `}
`;

export interface HeaderLinkProps {
  id: string;
  label: string;
  value: string;
}

export const HeaderLink: React.FC<HeaderLinkProps> = ({ id, label, value }) => {
  return (
    <StyledHeaderLink>
      <Grid
        key={id}
        container
        direction="column"
        justify="center"
        alignItems="flex-start">
        <Grid item>
          <p className="header-link-label">{label}</p>
        </Grid>
        <Grid item>
          <p className="header-link-text">{value}</p>
        </Grid>
      </Grid>
    </StyledHeaderLink>
  );
};
